// eslint-disable-next-line
import { BasicLayout } from '@/layouts'
// import { bxAnaalyse } from '@/core/icons'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

/**
 * 商家路由
 */
export const merchantRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '首页' },
    redirect: '/merchant/home',
    children: [
      {
        path: '/merchant/home',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '欢迎页面', icon: 'home', keepAlive: true, permission: ['dashboard'] }
      },
      {
        path: '/merchant/card',
        name: 'Card',
        component: () => import('@/views/merchant/card/index'),
        meta: { title: '服务卡', icon: 'credit-card', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/merchant/card/detail',
                name: 'CardDetail',
                component: () => import('@/views/merchant/card/detail'),
                meta: { title: '服务卡信息详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/merchant/prepay',
        name: 'PrePay',
        component: () => import('@/views/merchant/prepay/index'),
        meta: { title: '消费合约', icon: 'account-book', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/merchant/prepay/detail',
                name: 'PrePayDetail',
                component: () => import('@/views/merchant/prepay/PrePayDetail'),
                meta: { title: '消费合约详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/merchant/pay',
        name: 'Pay',
        component: () => import('@/views/merchant/pay/index'),
        meta: { title: '付款计划', icon: 'transaction', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/merchant/pay/detail',
                name: 'PayDetail',
                component: () => import('@/views/merchant/pay/detail'),
                meta: { title: '付款计划详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/merchant/payment',
        name: 'Payment',
        component: () => import('@/views/merchant/payment/index'),
        meta: { title: '付款单', icon: 'pay-circle', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/merchant/payment/detail',
                name: 'PaymentDetail',
                component: () => import('@/views/merchant/payment/detail'),
                meta: { title: '付款单详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      {
        path: '/merchant/cancelApply',
        name: 'CancelApply',
        component: () => import('@/views/merchant/cancelApply/index'),
        meta: { title: '退卡申请单', icon: 'solution', keepAlive: true, permission: ['dashboard'] },
        hideChildrenInMenu: true,
            children: [
              {
                path: '/merchant/cancelApply/Detail',
                name: 'ApplyDetail',
                component: () => import('@/views/merchant/cancelApply/Detail'),
                meta: { title: '退卡申请单详情', keepAlive: true, permission: ['form'] }
              }
            ]
      },
      // {
      //   path: '/merchant/userSearch',
      //   name: 'UserSearch',
      //   component: () => import('@/views/merchant/userSearch/index'),
      //   meta: { title: '用户搜索', icon: 'user', keepAlive: true, permission: ['dashboard'] },
      //   hideChildrenInMenu: true,
      //       children: [
      //         {
      //           path: '/merchant/userSearch/Detail',
      //           name: 'UserDetail',
      //           component: () => import('@/views/merchant/userSearch/Detail'),
      //           meta: { title: '用户信息详情', keepAlive: true, permission: ['form'] }
      //         }
      //       ]
      // },
      {
        path: '/merchant/person',
        component: RouteView,
        redirect: '/merchant/person/center',
        name: 'person',
        meta: { title: '商家档案', icon: 'user', keepAlive: true, permission: ['user'] },
        children: [
          {
            path: '/merchant/person/center',
            name: 'center',
            component: () => import('@/views/merchant/person/center'),
            meta: { title: '个人中心', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/merchant/person/settings',
            name: 'settings',
            component: () => import('@/views/merchant/person/settings/Index'),
            meta: { title: '个人设置', hideHeader: true, permission: ['user'] },
            redirect: '/merchant/person/settings/basic',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/merchant/person/settings/basic',
                name: 'BasicSettings',
                component: () => import('@/views/merchant/person/settings/BasicSetting'),
                meta: { title: '基本设置', hidden: true, permission: ['user'] }
              },
              {
                path: '/merchant/person/settings/security',
                name: 'SecuritySettings',
                component: () => import('@/views/merchant/person/settings/Security'),
                meta: {
                  title: '安全设置',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              },
              // {
              //   path: '/person/settings/custom',
              //   name: 'CustomSettings',
              //   component: () => import('@/views/merchant/person/settings/Custom'),
              //   meta: { title: '个性化', hidden: true, keepAlive: true, permission: ['user'] }
              // },
              {
                path: '/merchant/person/settings/binding',
                name: 'BindingSettings',
                component: () => import('@/views/merchant/person/settings/Binding'),
                meta: { title: '账号绑定', hidden: true, keepAlive: true, permission: ['user'] }
              },
              {
                path: '/merchant/person/settings/notification',
                name: 'NotificationSettings',
                component: () => import('@/views/merchant/person/settings/Notification'),
                meta: {
                  title: '新消息通知',
                  hidden: true,
                  keepAlive: true,
                  permission: ['user']
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
